module.exports = __webpack_public_path__ + "9956d65987582fe6262a33593d3164e6.svg";